import React from "react";
const PlusExpand = ({ className = "" }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="16.085"
    height="15.327"
    viewBox="0 0 16.085 15.327"
  >
    <g
      id="Group_30854"
      data-name="Group 30854"
      transform="translate(-275.915 -836.837)"
    >
      <g
        id="Group_30320"
        data-name="Group 30320"
        transform="translate(7266.915 -1742.163)"
      >
        <path
          id="Path_195"
          data-name="Path 195"
          d="M28.559,23.088V20.119h-6.3V14H19.3v6.119H13v2.969"
          transform="translate(-7004 2565)"
        />
        <path
          id="Path_196"
          data-name="Path 196"
          d="M45.877,57.324v6.208H42.908v-3.27Z"
          transform="translate(-7027.613 2530.795)"
        />
      </g>
      <g
        id="Group_30321"
        data-name="Group 30321"
        transform="translate(7266.915 -1742.163)"
      >
        <path
          id="Path_195-2"
          data-name="Path 195"
          d="M28.559,23.088V20.119h-6.3V14H19.3v6.119H13v2.969"
          transform="translate(-7004 2565)"
        />
        <path
          id="Path_196-2"
          data-name="Path 196"
          d="M45.877,57.324v6.208H42.908v-3.27Z"
          transform="translate(-7027.613 2530.795)"
        />
      </g>
      <rect
        id="Rectangle_15413"
        data-name="Rectangle 15413"
        width="16"
        height="3"
        transform="translate(276 843)"
      />
    </g>
  </svg>
);

export default PlusExpand;



// WEBPACK FOOTER //
// ./src/assets/PlusExpand.jsx